import React from 'react';
import PropTypes from 'prop-types';
import { StyledTruncated } from './style';

export const TruncatedText = ({ children, ...rest }) => (
  <StyledTruncated {...rest}>{children}</StyledTruncated>
);

TruncatedText.propTypes = {
  children: PropTypes.node.isRequired,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize: PropTypes.number,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowSize: PropTypes.number
};

TruncatedText.defaultProps = {
  fontWeight: 'normal',
  fontSize: 12,
  lineHeight: 1.2,
  rowSize: 1
};
